"use client";

import { useTranslation } from "react-i18next";
import Link from "next/link";
import { ROUTES } from "@constants/routes";
import Footer from "@components/footer/Footer";

export default function ErrorPage() {
  const { t } = useTranslation();

  return (
    <div className="h-screen text-center flex flex-col justify-between items-center">
      <div className="flex-1 flex flex-col items-center justify-center">
        <h2 className="text-6xl font-medium leading-tight mb-4">
          {t("errors.oops")}
        </h2>
        <p className="text-lg font-normal leading-6 mb-8">
          {t("errors.page-not-found")}
        </p>
        <Link
          href={ROUTES.root}
          className="py-3 px-6 border rounded-xl hover:bg-[var(--color-zinc-50)]"
        >
          {t("errors.back-button")}
        </Link>
      </div>
      <Footer />
    </div>
  );
}
